import script from "./video-message.vue?vue&type=script&lang=ts&setup=true"
export * from "./video-message.vue?vue&type=script&lang=ts&setup=true"

import "./video-message.vue?vue&type=style&index=0&id=8fa041c0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8fa041c0"]])

export default __exports__